import { CountryCode } from './countries'

export const CountryLocaleMap: Record<CountryCode, string> = {
  [CountryCode.US]: 'en_US',
  [CountryCode.SG]: 'en_US',
  [CountryCode.MY]: 'en_US',
  [CountryCode.HK]: 'zh_HK',
  [CountryCode.MO]: 'zh_HK',
  [CountryCode.TW]: 'zh_TW',
}
